import { loop } from 'cloop'
import moment from 'moment'
import $ from 'jquery'

var timers = []
loop(function () {
  for (var i = 0; i < timers.length; i++) {
    timers[i].update()
  }
})

function Timer(target) {
  this.target = moment(target)
  this.days = null
  this.hours = null
  this.minutes = null
  this.seconds = null
  this.isDone = null
  this.update()
  timers.push(this)
}

Timer.prototype.update = function () {
  var delta = this.target.diff(moment())

  if (delta < 0) {
    this.set(0, 0, 0, 0)
  }

  var seconds = Math.max(0, Math.floor(delta / 1000) || 0)
  var minutes =  Math.max(0, Math.floor(seconds / 60) || 0)
  var hours =  Math.max(0, Math.floor(minutes / 60) || 0)
  var days =  Math.max(0, Math.floor(hours / 24) || 0)

  this.set(days, hours % 24, minutes % 60, seconds % 60)
}

Timer.prototype.set = function (days, hours, minutes, seconds) {
  var changed = false
  var isDone = !(days || hours || minutes || seconds)

  if (days !== this.days) {
    this.days = days
    changed = true
  }

  if (hours !== this.hours) {
    this.hours = hours
    changed = true
  }

  if (minutes !== this.minutes) {
    this.minutes = minutes
    changed = true
  }

  if (seconds !== this.seconds) {
    this.seconds = seconds
    changed = true
  }

  if (changed) this.emit('change')

  if (this.isDone !== isDone) {
    this.isDone = isDone
    if (isDone) this.emit('stop')
    if (!isDone) this.emit('start')
  }
}

Timer.prototype.emit = function(eventName) {
  $(this).trigger(eventName)
}

Timer.prototype.on = function(eventName, handler) {
  $(this).on(eventName, handler)
}

export { Timer }

// Plugin
function twoDigit(n) {
  return (n < 10 ? '0' : '') + n
}

var countdowns = document.querySelectorAll('[data-countdown-to]');
for (var i = 0; i < countdowns.length; i++) {

  var el = countdowns[i]
  var timer = new Timer(el.dataset.countdownTo)
  window.__timer = timer

  // create dom structure
  el.innerHTML = '<div class="countdown">' +
      '<div class="countdown-unit">' +
        '<div class="countdown-value"></div>' +
        '<div class="countdown-label">Days</div>' +
      '</div>' +
      '<div class="countdown-unit">' +
        '<div class="countdown-value"></div>' +
        '<div class="countdown-label">Hours</div>' +
      '</div>' +
      '<div class="countdown-unit">' +
        '<div class="countdown-value"></div>' +
        '<div class="countdown-label">Minutes</div>' +
      '</div>' +
      '<div class="countdown-unit">' +
        '<div class="countdown-value"></div>' +
        '<div class="countdown-label">Seconds</div>' +
      '</div>' +
    '</div>';

  var nodes = el.querySelectorAll('.countdown-value')
  var units = ['days', 'hours', 'minutes', 'seconds']

  timer.on('change', function() {
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i]
      var unit = units[i]

      var value = twoDigit(timer[unit])
      if (node.innerHTML !== value) {
        node.innerHTML = value
      }
    }
  });

  timer.emit('change')
}

